// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete .cancel button{
    width: fit-content !important;
    background-color: #5c5c5c;
    color: #fff;
    border-radius: 0 !important;
    
}

.delete .cancel button:hover{
    width: fit-content !important;
    background-color: #9c9c9c;
    color: #fff;
    border-radius: 0 !important;
    
}

.delete .cancel{
    text-align: right;
    
}`, "",{"version":3,"sources":["webpack://./src/components/deleteAssure.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,2BAA2B;;AAE/B;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,2BAA2B;;AAE/B;;AAEA;IACI,iBAAiB;;AAErB","sourcesContent":[".delete .cancel button{\n    width: fit-content !important;\n    background-color: #5c5c5c;\n    color: #fff;\n    border-radius: 0 !important;\n    \n}\n\n.delete .cancel button:hover{\n    width: fit-content !important;\n    background-color: #9c9c9c;\n    color: #fff;\n    border-radius: 0 !important;\n    \n}\n\n.delete .cancel{\n    text-align: right;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
